import { Checkbox } from '@packages/shared/src/ui/Checkbox/Checkbox';
import type { InputHTMLAttributes } from 'react';

type CheckProps = {
  mandatory: boolean;
  id: string;
  selected: boolean;
} & Pick<InputHTMLAttributes<HTMLInputElement>, 'onChange'>;

/**
 * atom for Aplus - renders a checkbox or a checkmark
 */
export const Check = ({ mandatory, id, selected, onChange }: CheckProps) => {
  if (mandatory) {
    return <span className="icon-emp-checkmark text-color-success-dark m-0.5 h-3 w-3" role="img" />;
  }
  return (
    <Checkbox
      checked={selected}
      onChange={onChange}
      id={id}
      aria-checked={selected}
      className="cursor-pointer"
    />
  );
};
